import React from 'react';
import SellerContactOptionsButton from '../SellerContactOptionsButton';
import { ButtonIcon } from '@hz-design-system/web-ui';
import { Trans } from '@ecg-internal/js-react-i18n';

import Classes from '../SellerContactOptions.module.scss';

type Props = {
  onClick: () => void;
};

const BuyItNowButton = ({ onClick }: Props) => {
  return (
    <>
      <SellerContactOptionsButton className={Classes.button} isPrimary={true} onClick={onClick}>
        <ButtonIcon name="euros" isStartIcon={false} />
        <Trans tagName="span" className={Classes.text} i18nKey="sellerContact.buyItNow.button" />
      </SellerContactOptionsButton>
    </>
  );
};

export default BuyItNowButton;
